<template>
  <main class="wallet-success-page">
    <section class="wallet-success-body">
      <app-image src="@/assets/images/img_safe.png" alt="" class="hero-image" />
      <h1>{{ t('auth.canUseWallet') }}</h1>
      <p>{{ t('auth.successfullyProtected') }}</p>
      <AuthThemeButton block variant="secondary" class="start-btn" @click="goHome">
        {{ t('auth.startUseApp') }}
      </AuthThemeButton>
    </section>
  </main>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import AuthThemeButton from '@/view/auth/components/AuthThemeButton.vue';
import { useProfileStore } from '@/stores/profile';

const { t } = useI18n();
const router = useRouter();
const profileStore = useProfileStore();

function goHome() {
  router.replace('/home/index');
}
</script>

<style scoped lang="scss">
.wallet-success-page {
  min-height: var(--app-viewport-height);
  padding: 14px;
  background: radial-gradient(circle at 50% 20%, #d7e2ff 0%, #2667ff 70%);
}

.wallet-success-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(var(--app-viewport-height) - 28px);
  text-align: center;
}

.hero-image {
  flex: 1;
  width: min(280px, 80vw);
  max-height: 42vh;
  margin-top: 40px;
  object-fit: contain;
}

h1 {
  margin: 0;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
}

p {
  margin: 10px 16px 0;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.6;
}

.start-btn {
  width: 100%;
  margin: 100px 0 100px;
  color: #2667ff !important;
  background: #ffffff !important;
  box-shadow: none !important;
}
</style>
